export type TokenProvider = () => string | null;

/** Optional: millisecond window before token expiry to trigger proactive refresh */
export const DEFAULT_REFRESH_BEFORE_EXPIRY_MS = 5 * 60 * 1000; // 5 minutes

export interface SDKConfig {
  baseURL: string;
  getToken?: TokenProvider;
  onUnauthorized?: () => void;
  /** When to refresh before expiry (ms). If set, client can schedule proactive refresh. */
  refreshBeforeExpiryMs?: number;
  /** Optional extra headers per request (e.g. X-HRIA-Client for desktop/mobile identification). */
  getRequestHeaders?: () => Record<string, string>;
}

export interface Paginated<T> {
  items: T[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data?: T;
  code?: string;
  pagination?: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  }
}
